import { render } from "./AddSSHCollectorTarget.vue?vue&type=template&id=a1a51a06"
import script from "./AddSSHCollectorTarget.vue?vue&type=script&lang=js"
export * from "./AddSSHCollectorTarget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__